var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('hero'),_c('request-experiment'),_c('l-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }